<script setup lang="ts">
import { AppLinkButton } from '@libs/ui';

import HotelMainDescription from './HotelMainDescription.vue';

interface HotelMainDescriptionSectionProps {
  description: string;
}

const props = defineProps<HotelMainDescriptionSectionProps>();

interface HotelMainDescriptionSectionEmits {
  (eventName: 'open-full-description-modal'): void;
}

const emit = defineEmits<HotelMainDescriptionSectionEmits>();
</script>

<template>
  <div class="hotel-main-description-section">
    <div class="title">
      {{ $t('planner.about_the_hotel') }}
    </div>
    <HotelMainDescription :description="props.description" />
    <AppLinkButton
      :text="$t('planner.read_more')"
      size="large"
      @click="emit('open-full-description-modal')"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-main-description-section {
  .title {
    color: var(--color-secondary-40);
    @include font-heading-5;
  }
}
</style>
